module.exports = __webpack_public_path__ + "static/media/volcano.cff87989.svg";